import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { S25IconComponent } from "../../s25-icon/s25.icon.component";
import { S25ContactsEditableComponent } from "./s25.org.contacts.editable";
import { S25DropdownPaginatedModule } from "../../s25-dropdown/s25.dropdown.paginated.module";
import { S25OrgPartitionPrefsComponent } from "./s25.org.partition.prefs.component";
import { S25ItemModule } from "../../s25-item/s25.item.module";
import { S25OrgContactRolesComponent } from "./s25.org.contact.roles.component";
import { S25TableModule } from "../../s25-table/s25.table.module";

//@author: travis
@NgModule({
    declarations: [S25ContactsEditableComponent, S25OrgPartitionPrefsComponent, S25OrgContactRolesComponent],
    imports: [CommonModule, S25DropdownPaginatedModule, S25ItemModule, S25TableModule, S25IconComponent],
    exports: [S25ContactsEditableComponent, S25OrgPartitionPrefsComponent, S25OrgContactRolesComponent],
    providers: [S25ContactsEditableComponent, S25OrgPartitionPrefsComponent, S25OrgContactRolesComponent],
})
export class S25OrgDetailsModule {
    constructor() {}
}
